<template>
  <div id="app" :class="appClass">
    <div class="app-left">
      <xep-platform-aside ref="xepAside" v-if="showXepAside" @change-nav="changeNav"></xep-platform-aside>
    </div>
    <div class="app-right">
      <keep-alive :include="includeRoutes">
        <router-view></router-view>
      </keep-alive>
    </div>
    <div v-if="isLittleDoctor" class="back-door-doctor" title="点击小箭头可折叠或收起小博士按钮">
      <span :class="foldBackDoor ? 'el-icon-arrow-left' : 'el-icon-arrow-right'" @click="foldBackDoor = !foldBackDoor" style="margin-right: 2px;"></span>
      <el-switch v-show="foldBackDoor === false" v-model="backDoor" active-text="小博士开" inactive-text="小博士关" @change="setLittleDoctor">
      </el-switch>
    </div>
    <ul class="edge-bar" v-show="visible">
      <li class="qrcode-wrap">
        <div class="qrcode">
          <img v-if="$store.getters.isTest" src="~images/qrcode_testing.png" />
          <img v-else src="~images/qrcode.png" />
          <div>扫码关注公众号</div>
          <p>手机阅卷并查看报告</p>
        </div>
        <div class="icon icon-qrcode"></div>
      </li>
      <li v-show="isShow" @click="toTop()">
        <span>回到顶部</span>
        <div class="icon icon-top"></div>
      </li>
    </ul>
    <yue-dialog title="温馨提示" :visible.sync="notSubjectVisible" width="360px" center>
      <p style="line-height: 1.5;">您的帐号当前暂未绑定学科，可能导致您无法查看考试报告。详情请咨询管理员～</p>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="notSubjectVisible = false">
          我知道了
        </el-button>
      </span>
    </yue-dialog>

    <!-- 公告弹窗 -->
    <yue-notice :item="noticeDialogData" @close="closeNoticeDialog"></yue-notice>

    <!-- 过期无权限弹窗 -->
    <yue-no-permission :item="permissionItem"></yue-no-permission>

    <!-- 客户端更新弹窗 -->
    <yue-client-update :item="clientUpdateItem" @download="downloadExe" @close="closeClientUpdateDialog"></yue-client-update>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import util from '@/v2/utils/util'
import { magicApi } from '@/utils/magic'
import { clientApi, noticeApi, reportApi } from '@/v2/utils/api'

let timer = null;
export default {
  name: "App",
  data () {
    return {
      includeRoutes: ["DataStudent", "DataClass", 'BasePage'],
      isShow: false,
      backing: false,
      domain: window.location.host,
      backDoor: false,
      foldBackDoor: false,
      clientUrl: 'http://official.zxxk.com/client/RCEInstall.zip',
      notSubjectVisible: false, // 没有绑定学科的弹出是否显示
      noticeDialogData: {
        visible: false,
        data: {
          title: '',
          content: ''
        }
      },
      allNavs: [],
      activeNav: null,
      permissionItem: {
        type: 'no-permission',
        visible: false
      },
      clientUpdateItem: {
        type: 'index',
        visible: false,
      }
    };
  },

  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
    }),
    isLittleDoctor: function () {
      return (this.$store.getters.getUserInfo.productPermissionIds || []).indexOf('LittleDoctor') >= 0 || location.origin.indexOf('localhost') >= 0
    },
    visible () {
      return !['login', 'oauth', 'card-create', 'card-zujuan', 'warning-report-print', 'exam-marking-readPaper'].includes(this.$route.name)
    },
    // 展示xep导航栏的显示逻辑
    showXepAside () {
      return !!this.$route.query.xep_flag
    },
    // 展示应用组件的显示逻辑
    showDesktop: function () {
      return this.activeNav.navCode === 'gzt'
    },
    appClass () {
      let appClass = this.$options.filters.pageClassName(this.$route)
      if (this.showXepAside) {
        appClass += ' marking-is-xep'
      }
      return appClass
    }
  },
  mounted () {
    sessionStorage.removeItem("isAutoPaperStoreBackup");
  },
  methods: {
    setLittleDoctor: magicApi.setBackDoor,
    toTop () {
      clearInterval(timer);
      this.backing = true;

      timer = setInterval(_ => {
        let curHeight =
          document.documentElement.scrollTop || document.body.scrollTop;

        let speed = -curHeight / 4; // 随着高度减速
        speed = speed > 0 ? Math.ceil(speed) : Math.floor(speed);

        if (curHeight === 0) clearInterval(timer);

        document.documentElement.scrollTop = curHeight + speed;
        document.body.scrollTop = curHeight + speed; //谷歌

        this.backing = false;
      }, 25);
    },
    checkUserSubject: function () {
      const roles = this.$store.state.login.userInfo.roles
      if (roles && roles.length === 1) {
        this.notSubjectVisible = roles[0].roleName === '阅卷教师'
      }
      return this.notSubjectVisible
    },
    async getPopNotice () {
      const resp = await noticeApi.getPopNotice()
      if (resp.success) {
        if (resp.body) {
          this.viewNotice(resp.body)
        }
      } else {
        console.log('获取公告弹窗失败！')
        this.$message.warning(resp.message)
      }
    },

    viewNotice (notice) {
      this.noticeDialogData = {
        visible: true,
        data: notice
      }
    },
    // 关闭公告
    closeNoticeDialog (item) {
      this.noticeDialogData = {
        visible: false,
        data: {}
      }
      noticeApi.updateNoticeStatus(item.id).then(resp => {
        if (!resp.success) {
          this.$message.warning(resp.message)
        }
      })
    },
    /**
     * xep-platform-aside组件在加载完成之后，会发送该事件给应用，应用方根据需要接收导航数据
     * @param activeNav 当前选中的导航
     * @param allNavs 导航列表
     * 导航数据结构：
     * {
     *   id: 11, //导航id
     *   parentId: null, // 父级导航id
     *   navCode: 'gzt', //导航编码
     *   navName: '工作台', //导航名称
     *   navUrl: 'https://test-p.xkw.com/platform?service=gzt&xep_flag=1' //导航路径
     *   navTarget: 'SELF', //打开方式，SELF是当前页面打开，BLANK是新标签页打开
     *   needRoleIds:[], // 展示该菜单需要的b端权限
     * }
     */
    changeNav (activeNav, allNavs) {
      this.activeNav = activeNav;
      this.allNavs = allNavs;
    },
    checkAndGenerateReport (examId, next) {
      this.$confirm('已修改成绩，需要手动重新生成报告，是否现在立即重新生成？', '提示').then(() => {
        reportApi.refreshSingleReport({ examId: examId }).then(resp => {
          if (resp.success) {
            this.$message.success('报告生成成功')
          } else {
            this.$message.warning('报告生成失败')
          }
        });
      }).finally(() => {
        if (next) { next(); }
      })
    },
    showPermissionDialog (type = 'no-permission') {
      this.permissionItem.type = type
      this.permissionItem.visible = true
    },
    downloadExe () {
      clientApi.getExeUrl().then(url => {
        if (url) {
          this.updateClientUpdateStatus()
          util.download(url)
        } else {
          this.$message.error('下载失败')
        }
      })
    },
    // 检测客户端更新状态
    detectionClientUpdateStatus (type = 'index') {
      this.clientUpdateItem.type = type
      const isDetection = sessionStorage.getItem('isDetection')
      if (type === 'index' && isDetection === "true") {
        return false
      }
      clientApi.getClientUpdateState({
        schoolId: this.userInfo.schoolId,
        teacherId: this.userInfo.userId
      }).then(resp => {
        sessionStorage.setItem('isDetection', true)
        if (resp.success && resp.body) {
          this.clientUpdateItem.visible = true
        }
      })
    },
    // 修改客户端更新状态
    updateClientUpdateStatus () {
      sessionStorage.setItem('isDetection', false)
      clientApi.updateClientUpdateStatus({
        teacherId: this.userInfo.userId,
      }).then(resp => {
        if (!resp.success) {
          this.$message.warning(resp.message)
        }
      })
    },
    closeClientUpdateDialog () {
      if (this.clientUpdateItem.type === 'scan-batch') {
        this.updateClientUpdateStatus()
      }
    },
    openRegionLink (redirect, target = '_self') {
      if (this.userInfo.expiredSchool) {
        this.showPermissionDialog()
      } else {
        // 本地开发环境，需要跳转本地的区域平台
        const host = location.origin.indexOf('localhost') >= 0 ? 'http://localhost:8006' : location.origin
        const url = `${host}/region/oauth?isLittleDoctor=${this.isLittleDoctor}&token=${YJ_SCHOOL_STORAGE.getItem('token')}&redirect=${encodeURIComponent(redirect)}`;
        window.open(url, target)
      }
    }
  },
  filters: {
    pageClassName: function (route) {
      const parts = route.path.split('/')
      parts.unshift('yj-page')
      if (route.name) {
        parts.push(route.name + '_route')
      }
      return parts.join('-x ')
    }
  },
  watch: {
    '$store.state.backDoor': function (val) {
      this.backDoor = val
    },
    '$route.path': function () {
      const { path, meta } = this.$route
      // 绑定新一级导航归属
      if (path.indexOf('/exam/single') >= 0 || path.indexOf('/multiple/report') >= 0 || path.indexOf('/exam/marking/setting') >= 0) {
        meta.parentPath = '/v2/exam/index'
      } else if (path.indexOf('/exam/marking') >= 0) {
        meta.parentPath = '/v2/marking/index'
      } else if (path.indexOf('/tool/answerSheet') >= 0) {
        meta.parentPath = '/v2/card/index'
      }
      if (meta.url) {
        this.getPopNotice(meta)
      }
    }
  }
};
</script>


<style lang="scss">
@import "../node_modules/yuejuan-ui/lib/yuejuan-ui.css";
@import "../node_modules/xep-ui/lib/xep-ui.css";

.edge-bar {
  z-index: 999;
  position: fixed;
  right: 5px;
  top: calc(100vh - 320px);

  > li {
    margin-top: 20px;
    position: relative;
    cursor: pointer;
    border-radius: 50px;

    &.qrcode-wrap:hover {
      .qrcode {
        width: 155px;
        height: 222px;
        opacity: 1;
      }
    }

    &:hover {
      span {
        width: 110px;
        display: inline-block;
        background-color: $color-theme;
      }

      span.client {
        width: 150px;
        cursor: pointer;
      }

      .icon {
        background-color: $color-theme;

        &.icon-qrcode {
          border-radius: 0 50px 50px 0;
        }

        &.icon-helper {
          background-image: url(~images/layout/helper_white_icon.png);
        }

        &.icon-top {
          background-image: url(~images/layout/top_white_icon.png);
        }
      }
    }

    span {
      display: block;
      width: 0;
      margin-right: 25px;
      overflow: hidden;
      white-space: nowrap;
      height: 50px;
      line-height: 50px;
      border-radius: 50px 0 0 50px;
      font-size: 14px;
      color: #fff;
      background-color: #fff;
      position: absolute;
      right: 0;
      text-indent: 20px;
      transition: width 0.2s, background-color 0.2s;
    }

    .icon {
      display: inline-block;
      width: 50px;
      height: 50px;
      line-height: 45px;
      border-radius: 50%;
      text-align: center;
      background-color: #fff;
      box-shadow: 0px 4px 8px rgba(102, 102, 102, 0.16);
      position: relative;
      background-position: center;
      background-repeat: no-repeat;
      // background-size: 22px 22px;
      transition: background-color 0.2s;

      &.icon-qrcode {
        background-color: $color-theme;
        background-image: url(~images/layout/qrcode_icon.png);
      }

      &.icon-helper {
        background-image: url(~images/layout/helper_icon.png);
      }

      &.icon-top {
        background-image: url(~images/layout/top_icon.png);
      }
    }
  }
}

#app {
  width: 100%;
  height: 100%;
}

#toTop {
  z-index: 999;
  position: fixed;
  right: 5px;
  bottom: 65px;
  width: 50px;
  height: 50px;
  background: url(~images/back_top_top.png) no-repeat;
  box-shadow: 0 0 5px #eee;
  cursor: pointer;
  border-radius: 2px;
  opacity: 0.8;
}

#toTop:hover {
  opacity: 1;
  box-shadow: 0 1px 5px #ccc;
}

.qrcode {
  opacity: 0;
  z-index: 1;
  position: absolute;
  right: 50px;
  padding: 12px 11px;
  width: 0;
  height: 0;
  overflow: hidden;
  background-color: $color-theme;
  color: #fff;
  text-align: center;
  box-sizing: border-box;
  border-radius: 3px 0 3px 3px;
  transition: width 0.2s;

  img {
    width: 133px;
    height: 133px;
  }

  div {
    padding-top: 12px;
    line-height: 24px;
    font-size: 14px;
    white-space: nowrap;
  }

  p {
    font-size: 12px;
    line-height: 26px;
    white-space: nowrap;
  }
}

.img-viewr__mask {
  opacity: 1 !important;
}

.back-door-doctor {
  position: fixed;
  left: 10px;
  bottom: 10px;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
  background-color: white;
  z-index: 10000;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  align-items: center;
}

.system-x .container {
  padding-top: 40px !important;
}

.marking-is-xep {
  .app-left {
    width: 130px;
    height: 100vh;
    position: fixed;
    z-index: 1;
  }

  .app-right {
    width: calc(100% - 130px);
    margin-left: 130px;
    position: relative;

    .main-tabs,
    .gaokao-exam .top,
    .sub-tabs,
    .answerSheet .header,
    .answerSheet-zj .header {
      left: 130px;
    }
  }
  .el-icon-user {
    display: none;
  }

  .el-table--group::after,
  .el-table--border::after,
  .el-table::before {
    z-index: 0;
  }
}

.client-update-dialog .el-dialog__footer .el-button {
  width: auto;
  padding: 0 10px;
}
</style>
